<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand fw-bold">Assets Monitor Tool</a>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()" [attr.aria-expanded]="!isCollapsed" aria-controls="navbarNav" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" [class.show]="!isCollapsed" id="navbarNav">
      <ul class="navbar-nav mb-2 mb-lg-0">
        <li class="nav-item dropdown position-relative" (document:click)="closeSettingsMenu()">
          <a class="nav-link dropdown-toggle" href="#" id="settingsDropdown" role="button"
             [attr.aria-expanded]="showSettingsMenu" (click)="toggleSettingsMenu($event)">
            Settings
          </a>
          <ul class="dropdown-menu dropdown-menu-end show" *ngIf="showSettingsMenu" aria-labelledby="settingsDropdown" style="position: absolute;">
            <!-- <li><a class="dropdown-item" routerLink="/settings" (click)="closeSettingsMenu()">Settings</a></li>
            <li><hr class="dropdown-divider"></li> -->
            <li><a class="dropdown-item text-danger" href="#" (click)="clearCacheAndReload(); closeSettingsMenu(); $event.preventDefault();">Clear Cache</a></li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" (click)="logout(); $event.preventDefault();">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
